import { css } from "@emotion/css";

import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

type TaskItemsHeaderProps = {
  children: React.ReactNode;
};

export const TaskItemsHeader: React.FC<TaskItemsHeaderProps> = ({
  children,
}) => {
  const classes = createTaskItemsHeaderStyles(useTheme());
  return (
    <Typography variant="subheading" className={classes.root}>
      {children}
    </Typography>
  );
};

function createTaskItemsHeaderStyles({ typography, spacing }: Theme) {
  return {
    root: css({
      fontWeight: typography.fontWeight.medium,
      margin: spacing([2, 0, 1, 0]),
      color: grey[900],
      fontSize: typography.fontSize.default,
    }),
  };
}
